// 리치 에디터(Quill)가 만들어내는 블록/인라인 태그. 이 중 하나라도 있으면 HTML 본문으로 본다.
// 범용 `<[a-z]...>` 판정은 "a<b>c" 같은 순수 텍스트까지 HTML 로 오인하므로 태그를 한정한다.
const EDITOR_HTML_TAG_PATTERN = /<\/?(p|br|div|span|img|a|strong|em|u|s|ol|ul|li|h[1-6])\b[^>]*>/i;

const escapeHtml = (text: string): string => text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

/**
 * 공지 본문이 비었는지 판정한다.
 * Quill 은 빈 본문도 `<p><br></p>` 로 내보내므로 태그를 걷어낸 텍스트로 본다.
 * 이미지만 첨부된 본문은 비어있지 않다.
 */
export const isBlankNoticeContent = (html: string): boolean => {
  if (/<img\b/i.test(html)) return false;
  return (
    html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim().length === 0
  );
};

/**
 * 리치 에디터 도입 전 순수 텍스트로 저장된 공지를 에디터용 HTML 로 바꾼다.
 * 그대로 Quill 에 넣으면 줄바꿈이 공백으로 합쳐지므로 줄마다 `<p>` 로 감싼다.
 * 이미 HTML 인 본문은 그대로 돌려준다.
 */
export const toNoticeEditorHtml = (content: string): string => {
  if (!content || EDITOR_HTML_TAG_PATTERN.test(content)) return content;
  return content
    .split(/\r?\n/)
    .map((line) => `<p>${line ? escapeHtml(line) : "<br>"}</p>`)
    .join("");
};
